import {useDistricts} from "../../../hooks";
import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import Select from "react-select";

const WardSelect = ({districtId, ...props}) => {
    const { isLevel2 } = props;
    const { t } = useTranslation(["order"]);
    const { data: wards, refetch: refetchWards } =
        useDistricts({
            countryId: 1,
            type: 3,
            parent_code: districtId,
            record_status: isLevel2 ? "O" : "C",
        });
    useEffect(() => {
        refetchWards()
    }, [districtId, isLevel2])
    const options = []
    for (const key in wards) {
        options.push({
            label: wards[key],
            value: key
        })
    }
    if (props.value && !props.value.label) {
        props.value.label = options.find(e => e.value == props.value.value)?.label
    }
    return <Select
        {...props}
        placeholder={t("placeholder.select", {
            title: t("form.receiver_ward_code"),
        })}
        options={options}
        classNamePrefix="select2-selection"
    />
}
export default WardSelect
